import { ModalProgrammatic as Modal } from 'buefy'

const create = (page, component, name, type = null) => {
	history.pushState({}, '', `/${page}`)
	history.pushState({}, '', `${page}/create`)

	var modal = Modal.open({
		parent: this,
		component: component,
		scroll: 'keep',
		customClass: 'is-' + page,
		trapFocus: true,
		onCancel: () => {
			history.pushState({}, '', `/${page}`)
		},
		props: {
			name: name,
			type: type
		}
	})

	modal.$on('close', () => history.pushState({}, '', `/${page}`))
}

const update = (page, id, component, name, root = null, type = null) => {
	history.pushState({}, '', `/${page}`)
	history.pushState({}, '', `${page}/edit/${id}`)

	var modal

	if (root === 'root') {
		modal = Modal.open({
			parent: this,
			component: component,
			scroll: 'clip',
			customClass: 'is-' + page,
			trapFocus: true,
			onCancel: () => {
				history.pushState({}, '', `/${page}`)
			},
			props: {
				id: id,
				name: name,
				root: root,
				type: type
			}
		})
	} else {
		modal = Modal.open({
			parent: this,
			component: component,
			scroll: 'clip',
			customClass: 'is-' + page,
			trapFocus: true,
			onCancel: () => {
				history.pushState({}, '', `/${page}`)
			},
			props: {
				id: id,
				name: name,
				type: type
			}
		})
	}

	modal.$on('close', () => history.pushState({}, '', `/${page}`))
}

const rate = (parent, page, id, component, optionalProps) => {
	history.pushState({}, '', `/${page}`)
	history.pushState({}, '', `${page}/rate/${id}`)

	var modal
	modal = Modal.open({
		parent: parent,
		component: component,
		scroll: 'clip',
		customClass: 'is-' + page,
		trapFocus: true,
		onCancel: () => {
			history.pushState({}, '', `/${page}`)
		},
		props: {
			id: id,
			...optionalProps
		}
	})

	modal.$on('close', () => history.pushState({}, '', `/${page}`))
}

export { create, update, rate }
